import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../assets/styles/SareesPage.css";
import { getAllAccessories } from "../service/accessoryService";

const AccessoriesPage = () => {
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);

  useEffect(() => {
    const run = async () => {
      try {
        setLoading(true);
        const apiItems = await getAllAccessories();
        setItems(apiItems);
      } catch (error) {
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    run();
  }, []);

  return (
    <div className="sarees-page">
      <div className="sarees-hero-banner">
        <img
          src="https://images.unsplash.com/photo-1611652022419-a9419f74343d?auto=format&fit=crop&w=1600&q=80"
          alt="Accessories Collection Banner"
          onError={(e) => {
            e.target.style.display = "none";
          }}
        />
        <div className="sarees-hero-overlay">
          <h1>Accessories</h1>
        </div>
      </div>

      <div className="breadcrumb" style={{ marginTop: "14px" }}>
        <Link to="/">Home</Link> / Accessories
      </div>

      {loading && <div className="sarees-loading">Loading accessories...</div>}

      {!loading && items.length > 0 && (
        <div className="sarees-categories-section">
          <div className="sarees-category-cards">
            {items.map((acc) => (
              <Link
                key={acc._id || acc.id}
                to={`/product/${acc.isProduct ? acc._id : acc.parentProductId}`}
                className="saree-card-link"
              >
                <div className="saree-card">
                  <img
                    src={acc.images?.[0]}
                    alt={acc.name || "Accessory"}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                  <div className="saree-card-overlay">
                    <h3>{acc.name || "Accessory"}</h3>
                    <p className="saree-card-price">{acc.price}</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}

      {!loading && items.length === 0 && (
        <div className="sarees-empty">
          No accessories available at the moment. Please check back later.
        </div>
      )}
    </div>
  );
};

export default AccessoriesPage;
